import { useEffect } from 'react';

export type Theme = 'system' | 'light' | 'dark';

export function applyTheme(theme: Theme) {
  const dark = theme === 'dark' || (theme === 'system' && window.matchMedia('(prefers-color-scheme: dark)').matches);
  document.documentElement.dataset.theme = dark ? 'dark' : 'light';
  try { localStorage.setItem('lumnos.theme', theme); } catch { /* storage unavailable */ }
}

export function useTheme(theme: Theme | undefined) {
  useEffect(() => {
    const t = theme ?? ((() => { try { return localStorage.getItem('lumnos.theme') as Theme | null; } catch { return null; } })() ?? 'system');
    applyTheme(t);
    if (t !== 'system') return;
    const mq = window.matchMedia('(prefers-color-scheme: dark)');
    const fn = () => applyTheme('system');
    mq.addEventListener('change', fn);
    return () => mq.removeEventListener('change', fn);
  }, [theme]);
}
